import useTranslation from './useTranslation';

const useStructuredData = (product) => {
    const { t, currency, locale } = useTranslation();
    const firstDay = new Date();
    const nextWeek = new Date(firstDay.getTime() + 7 * 24 * 60 * 60 * 1000);

    const getImagesURL = (images) => {
        if (images) {
            return images.map((image) => image.urls.large);
        }
        return [];
    };
    const productStructuredData = {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        name: `${product?.name[locale]}`,
        image: getImagesURL(product?.images),
        description: `${product?.description[locale]}`,
        sku: `${product?.sku}`,
        brand: {
            '@type': 'Brand',
            name: 'Fervente',
        },

        offers: {
            '@type': 'Offer',
            url: `https://www.ferventeshop.com/${t('productSlug')}/${
                product.slug[locale]
            }`,
            priceCurrency: currency,
            price: product?.discounted_price[currency],
            priceValidUntil: `${nextWeek.toISOString().split('T')[0]}`,
            itemCondition: 'https://schema.org/NewCondition',
            availability: 'https://schema.org/InStock',
        },
        // aggregateRating: {
        //     '@type': 'AggregateRating',
        //     ratingValue: '4.4',
        //     reviewCount: '89',
        // },
    };
    const breadcrumbData = [
        {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
                {
                    '@type': 'ListItem',
                    position: 1,
                    item: 'https://www.ferventeshop.com/',
                    name: 'Fervente',
                },
                {
                    '@type': 'ListItem',
                    position: 2,
                    item: `https://www.ferventeshop.com/${product?.category[0]?.parent?.slug[locale]}`,
                    name: `${product?.category[0]?.parent?.name[locale]}`,
                },
                {
                    '@type': 'ListItem',
                    position: 3,
                    item: `https://www.ferventeshop.com/${product?.category[0]?.slug[locale]}`,
                    name: `${product?.category[0]?.name[locale]}`,
                },
                {
                    '@type': 'ListItem',
                    position: 4,
                    name: `${product?.name[locale]}`,
                },
            ],
        },
    ];
    return [breadcrumbData, productStructuredData];
};

export default useStructuredData;
